import { useEffect, useRef } from "react"
import { isIOS } from "react-device-detect"
import { useAppSelector } from "../../../../store/hooks"
import { BodyScrollLock } from "../../../../utils/scrollLock"

export const BaseViewModel = () => {
    const initialHeight = useRef<number>(window.innerHeight)
    const listRef = useRef<any>(null)

    const handleResize = () => {
        if (!isIOS) {
            return
        }
        window.scrollTo(0, 0)
        const isKeyboardOpen = window.visualViewport
            ? window.visualViewport?.height < initialHeight.current - 150
            : undefined
        if (isKeyboardOpen === undefined) return
        if (listRef.current)
            listRef.current.style.height = `${window.visualViewport?.height}px`
        if (isKeyboardOpen) {
            BodyScrollLock.disableBodyScroll(document.body, {
                reserveScrollBarGap: false,
                allowTouchMove: (el) => {
                    const e = el as HTMLElement
                    if (e && e.classList.contains("search-result")) {
                        return true
                    }
                    return false
                },
            })
        } else {
            BodyScrollLock.clearAllBodyScrollLocks()
        }
    }

    useEffect(() => {
        window.visualViewport?.addEventListener("resize", handleResize)
        return () => {
            window.visualViewport?.removeEventListener("resize", handleResize)
            BodyScrollLock.clearAllBodyScrollLocks()
        }
    }, [handleResize])

    const source = useAppSelector(
        (state) => state.messaging.newConversationSearchSource,
    )

    return {
        listRef,
        source,
    }
}
